import React from 'react';
import loadable from '@loadable/component';

const ReferralContainer = loadable(() => import('./ReferralContainer'));

export default () => ({
  path: 'referral',

  indexRoute: {
    component: props => <ReferralContainer {...props} />,
  },

  childRoutes: [
    {
      path: '*',
      component: props => <ReferralContainer {...props} />,
    },
  ],
});
